export const ALL_PRODUCT_TYPE_REQUEST = "ALL_PRODUCT_TYPE_REQUEST"
export const ALL_PRODUCT_TYPE_SUCCESS = "ALL_PRODUCT_TYPE_SUCCESS"
export const ALL_PRODUCT_TYPE_FAIL = "ALL_PRODUCT_TYPE_FAIL"

export const ALL_PRODUCT_TYPE_POST_REQUEST = "ALL_PRODUCT_TYPE_POST_REQUEST"
export const ALL_PRODUCT_TYPE_POST_SUCCESS = "ALL_PRODUCT_TYPE_POST_SUCCESS"
export const ALL_PRODUCT_TYPE_POST_FAIL = "ALL_PRODUCT_TYPE_POST_FAIL"

export const ALL_PRODUCT_TYPE_UPDATE_REQUEST = "ALL_PRODUCT_TYPE_UPDATE_REQUEST"
export const ALL_PRODUCT_TYPE_UPDATE_SUCCESS = "ALL_PRODUCT_TYPE_UPDATE_SUCCESS"
export const ALL_PRODUCT_TYPE_UPDATE_FAIL = "ALL_PRODUCT_TYPE_UPDATE_FAIL"

export const ALL_PRODUCT_TYPE_DETAILS_REQUEST = "ALL_PRODUCT_TYPE_DETAILS_REQUEST"
export const ALL_PRODUCT_TYPE_DETAILS_SUCCESS = "ALL_PRODUCT_TYPE_DETAILS_SUCCESS"
export const ALL_PRODUCT_TYPE_DETAILS_FAIL = "ALL_PRODUCT_TYPE_DETAILS_FAIL"

export const ALL_PRODUCT_TYPE_DELETE_REQUEST = "ALL_PRODUCT_TYPE_DELETE_REQUEST"
export const ALL_PRODUCT_TYPE_DELETE_SUCCESS = "ALL_PRODUCT_TYPE_DELETE_SUCCESS"
export const ALL_PRODUCT_TYPE_DELETE_FAIL = "ALL_COMPANY_DELETE_FAIL"

export const CLEAR_ERRORS = "CLEAR_ERRORS"